export default __webpack_public_path__ + "static/media/pantry1-afterD-1024w.fa2cd69b.webp";